// Accordion Block - Collapsible content sections
class AccordionBlock {
  static get toolbox() {
    return {
      title: 'Accordion',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      title: data.title || 'Click to expand',
      content: data.content || '',
      isOpen: data.isOpen || false
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden" data-testid="accordion-block">
        <button class="accordion-header w-full flex items-center justify-between px-4 py-3 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
          <span class="accordion-title font-medium text-slate-900 dark:text-white" contenteditable="${!this.readOnly}">${this.data.title}</span>
          <svg class="w-5 h-5 text-slate-500 transition-transform ${this.data.isOpen ? 'rotate-180' : ''}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </button>
        <div class="accordion-content ${this.data.isOpen ? '' : 'hidden'} px-4 py-3 bg-white dark:bg-slate-900">
          <div class="content-editor text-slate-700 dark:text-slate-300" contenteditable="${!this.readOnly}" data-placeholder="Content...">${this.data.content}</div>
        </div>
      </div>
    `;

    const header = this.wrapper.querySelector('.accordion-header');
    const title = this.wrapper.querySelector('.accordion-title');
    const content = this.wrapper.querySelector('.content-editor');

    header?.addEventListener('click', (e) => {
      if (e.target === title) return;
      this.data.isOpen = !this.data.isOpen;
      this._render();
    });

    if (!this.readOnly) {
      title?.addEventListener('input', (e) => {
        this.data.title = e.target.textContent;
      });
      content?.addEventListener('input', (e) => {
        this.data.content = e.target.innerHTML;
      });
    }
  }

  save() {
    return this.data;
  }
}

export default AccordionBlock;
